<template>
	<b-modal
		id="renameresume"
		size="md"
		centered
		hide-footer
		hide-header
		v-model="showModal"
		@hidden="$emit('close-modal')"
	>
		<div class="d-flex">
			<div class="w-100">
				<div class="candash-modal-body-3 p-3">
					<div class="rpro-flex-1">
						<div>
							<img
								class="rpro-svg-size"
								src="@/assets/newdesign/dashboard/creaNewPro.svg"
								alt=""
							/>
						</div>
						<div class="rpro-w95 rpro-text pl-3">
							<div class="d-flex align-items-center justify-content-between">
								<div class="candash-modal-head rpro-txt-center">
									Rename <span>Profile</span>
								</div>
								<div
									id="hideinmobile"
									class="pointer"
									@click="$emit('close-modal')"
								>
									<img
										class="rotate-on-hover"
										src="@/assets/newdesign/dashboard/blueCross.svg"
										alt=""
									/>
								</div>
							</div>
							<div class="candash-blackTxt mt-3">Profile Name</div>
							<div class="w95 mt-2 position-relative">
								<b-form-input
									placeholder="Enter name of the resume"
									type="text"
									:class="
										resumeNameNew.length > 20 || resumeNameNew.trim() === ''
											? 'laptopinput-error'
											: 'laptopinput'
									"
									v-model="resumeNameNew"
								></b-form-input>
								<div
									v-if="resumeNameNew.length > 20"
									class="candash-errortxt errortxt-pos"
								>
									Exceeded the max char length of 20
								</div>
								<div
									v-else-if="resumeNameNew.trim() === ''"
									class="candash-errortxt errortxt-pos"
								>
									Required
								</div>
							</div>
						</div>
					</div>
				</div>
				<div
					class="p-3 d-flex align-items-center rpro-justify-cont mt-3 rpro-border-top"
				>
					<b-button
						class="candash-cancelBtn mr-4 pointer rpro-40"
						@click="$emit('close-modal')"
						>Cancel</b-button
					>

					<div class="position-relative rpro-40">
						<b-button
							class="candash-customBtn-vr pointer rpro-100"
							:class="
								isRenaming ? 'loader-class-rename defaultCursor ' : 'pointer'
							"
							:disabled="
								resumeNameNew === localCandidateInfo.profileName ||
								resumeNameNew.length > 20 ||
								resumeNameNew.trim() === ''
							"
							@click="!isRenaming ? renameResume() : null"
						>
							{{ isRenaming ? "" : "Rename" }}
						</b-button>
						<div v-if="isRenaming" class="loader-pos-new">
							<Loader />
						</div>
					</div>
				</div>
			</div>
		</div>
	</b-modal>
</template>

<script>
import Loader from "@/components/fixedcomponents/Loader.vue";
import { renameResume } from "@/utils/apiFunctions";
import { getCandidateDetail } from "@/controllers/dashboard/asynchronous";
import successModal from "@/components/mixin/toast";
import errorModal from "@/components/mixin/toast";
export default {
	name: "RenameProfile",
	data() {
		return {
			resumeNameNew: this.localCandidateInfo.profileName,
			isRenaming: false,
		};
	},
	props: {
		showModal: {
			type: Boolean,
			default: false,
		},
		localCandidateInfo: {
			type: Object,
			default: () => {},
		},
	},
	mixins: [successModal, errorModal],
	components: {
		Loader,
	},
	methods: {
		async renameResume() {
			if (this.resumeNameNew.trim() === "") {
				return;
			}

			this.isRenaming = true;

			try {
				const res = await renameResume({
					_id: this.localCandidateInfo._id,
					profileName: this.resumeNameNew,
				});

				if (res.status === 200) {
					this.successModal(
						"Successfully renamed.",
						"Resume has been renamed."
					);
					this.getCandidateDetailTabs();
					this.$emit("update-profile");
				} else if (res.status === 409) {
					this.isRenaming = false;
					return this.errorModal("Error", "Resume with same name exists!");
				} else {
					this.errorModal("Error", "Something went wrong!");
				}
			} catch (error) {
				this.errorModal("Error", "Something went wrong!");
			}
			this.$emit("close-modal");
		},
		async getCandidateDetailTabs() {
			this.localCandidateInfo = await getCandidateDetail();
			this.$store.commit(
				"candidateVUEX/setCandidateInfo",
				this.localCandidateInfo
			);
		},
	},
};
</script>
<style>
.rpro-flex-1 {
	display: flex;
	align-items: flex-start;
}

.rpro-justify-cont {
	justify-content: flex-end;
}
.rpro-border-top {
	border-top: 1px solid #ffffff;
}
.rpro-w95 {
	width: 95%;
}
@media (max-width: 1028px) {
	.rpro-flex-1 {
		flex-direction: column;
		align-items: center;
	}
	.rpro-text {
		padding-left: 0 !important;

		margin-top: 15px;
	}
	.rpro-txt-center {
		text-align: center;
		width: 100%;
	}
	.rpro-justify-cont {
		justify-content: center;
	}
	.rpro-border-top {
		border-top: 1px solid #d9d9d9;
	}

	.rpro-40 {
		width: 45%;
	}
	.rpro-100 {
		width: 100%;
	}
	.rpro-svg-size {
		height: 50px;
	}
	.rpro-w95 {
		width: 100%;
	}
}
</style>
